<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-sack-dollar" />&nbsp;{{ $t('assets') }}
        </template>
        <AssetsTable />
    </PageWrapper>
</template>
<script setup lang="ts">
import PageWrapper from '@partials/pages/PageWrapper.vue'
import AssetsTable from '@partials/assets/AssetsTable.vue'
</script>

<style lang="scss" scoped></style>
